/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>导购工具</el-breadcrumb-item>
      <el-breadcrumb-item>签约管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formProInfo" class="user-search">
			
			<el-form-item label="签约人姓名" class="huan">
			 <el-input size="small" v-model="formProInfo.name" placeholder="输入姓名"></el-input>
			</el-form-item>
			
          <el-form-item label="签约方式" >
            <el-input size="small" v-model="formProInfo.signType" placeholder="输入签约方式"></el-input>
          </el-form-item>
		  
    	  <el-form-item label="签约人电话" class="huan">
    	    <el-input size="small" v-model="formProInfo.phone" placeholder="输入签约人电话"></el-input>
    	  </el-form-item>
		  
		  
			<el-button size="small" type="info" icon="el-icon-refresh-left" @click="refrea" class="refrea">重置</el-button>
			<el-button size="small" type="primary" icon="el-icon-search" @click="search" class="search">搜索</el-button>
           
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" prop="secondPartyName" label="签约人名称" >
		  </el-table-column>
		  <el-table-column align="center" prop="secondPartyPhone" label="签约人电话" >
		  </el-table-column>
		  <el-table-column align="center" prop="signType" label="签约方式" >
		  </el-table-column>
		  <el-table-column align="center" prop="signDate" label="签约时间" >
		  </el-table-column>
         
          <el-table-column  align="center"  label="操作" min-width="140">
            <template slot-scope="scope">

              <!-- <el-button size="mini" type="success" @click="getDatas(scope.$index, scope.row.id)">查看</el-button> -->
              <el-button size="mini"  type="primary" @click="handleEdit(scope.row)">详情</el-button>
			  <!-- <el-button size="mini" type="danger" @click="deleteProInfo(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        
      </div>
    </template>

    <script>
    import {
      getesign
	  
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
         
          // 请求数据参数
          formProInfo: {
            pageIndex: 1,
            pageSize: 10,
            // 产品名称(支持右模糊查询)
            name: '',
            phone: '',
            signType:''
			
          },
    	  proInfoList:[],
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          }
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getData(this.formProInfo)

      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  //添加
		  add: function() {
		  	this.$router.push({ path: '/businesscard?shuo=' + '新增'})
		   
		  },
		  //编辑
		  handleEdit: function(row) {
		  	console.log(99999,row)
			let types = ''
			if(row.secondPartyType==1){
				types = 'represent'
			}else if(row.secondPartyType==2){
				types = 'customer'
			}else if(row.secondPartyType==3){
				types = 'energy'
			}
		  	this.$router.push({ path: '/signadd?id='+row.id + '&types=' + types})
		   
		  },
		  changetype(e){
			  console.log(123456,e)
			  //this.formProInfo.firstLevelId = e
			  let parm = {
					 level:2,
					 category:3,
					 firstLevelId:this.formProInfo.firstLevelId,
					 secondLevelId:''
						 
			  }
			  getShoppyTypeList(parm).then(res => {
				console.log(123)
				this.loading = false
				if (res.success == false) {
				  this.$message({
					type: 'info',
					message: res.msg
				  })
				} else {
				this.formProInfo.secondLevelId = null
				this.formProInfo.thirdLevelId = null
				this.typeList2 = res.data
				
				}
			  })
		  },
		  
		refrea(){
			this.formProInfo.name=''
			this.formProInfo.signType=''
			this.formProInfo.phone=''
		},
       // 选择复选框事件
       selectChange(val) {
         this.selectdata = val
       },

        // 获取数据方法
        getData(pageparm) {
          this.loading = true
          getesign(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.proInfoList = res.data
			  this.proInfoList.map((item,index) =>{
				  item.adrees = item.province + item.city + item.county
				  if(item.signType == 'esign'){
					  item.signType = '电子签约'
				  }else{
					  item.signType = '附件上传'
				  }
			  })

              // 分页赋值
              this.pageparm.currentPage = this.formProInfo.pageIndex
              this.pageparm.pageSize = this.formProInfo.pageSize
              this.pageparm.total = res.total
            }
          })
        },
        // 分页插件事件
        callFather(parm) {
          this.formProInfo.pageIndex = parm.currentPage
          this.formProInfo.pageSize = parm.pageSize
          this.getData(this.formProInfo)
        },
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
  	  width: 220px;
  }
  .el-input{
  	  width: 140px;
  }
  /deep/ .el-input--small{
  	  width: 140px;
  }
  /deep/ .el-form--inline .el-form-item__label{
	  width: 80px;
	  overflow-wrap: break-word;
	  
  }
  /deep/ .huan .el-form-item__label{
  	  line-height: 20px;
  	  
  }
  /* .search{
	  position: absolute;
	  right: 0;
	  top: 68px;
  } */
  .add{
	  margin-bottom: 30px;
  }
  .el-button--small{
	margin-top: 5px;  
  }
  /* .refrea{
	  position: absolute;
	  right: 0;
	  top: 5px;
  } */
  /* .user-search{
	  position: relative;
  } */
    </style>





// WEBPACK FOOTER //
// src/views/guidetool/sign.vue